import { render, staticRenderFns } from "./PetHealth.vue?vue&type=template&id=ff2188b2&scoped=true&"
import script from "./PetHealth.vue?vue&type=script&lang=js&"
export * from "./PetHealth.vue?vue&type=script&lang=js&"
import style0 from "./PetHealth.vue?vue&type=style&index=0&id=ff2188b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff2188b2",
  null
  
)

export default component.exports